// extracted by mini-css-extract-plugin
export default {"mobile":"n5TTun","root":"W2ZNnD","onImage":"kVDYpL"};